// [기본]
// 결제수단은 여러개일 수 있다.
// 선결제 (보통 주문시 바로 결제하는..)와
// 현금 (당연히 만나서..)
// 카드 (선결제와 구분 된다. 만나서 카드에 한 함)
// [설명]
// 각각의 금액이 존재한다면 해당 결제방법을 사용한다는 것을 의미한다.
// payCashAmount 가 1000 이고
// payCardAmount 가 1000 이라면
// 현금과 신용카드로 나눠서 결제한다고 보면 된다.
const lc = 'views.order_list.order_list_item.';
/** 현금 결제 */
export const PAY_CASH_AMOUNT = 'PAY_CASH_AMOUNT';
/** 카드 결제 */
export const PAY_CARD_AMOUNT = 'PAY_CARD_AMOUNT';
/** 선결제 (선결제는 카드, 현금을 구분하지 않음) */
export const PRE_PAY_AMOUNT = 'PRE_PAY_AMOUNT';
/** 0원결제 */
export const ZERO_ORDER_AMOUNT = 'ZERO_ORDER_AMOUNT';
export const payMethodType = {
    PAY_CASH_AMOUNT,
    PAY_CARD_AMOUNT,
    PRE_PAY_AMOUNT,
    ZERO_ORDER_AMOUNT,
};
/**
 * 결제수단
 * payTypeCode는 만나서 결제할지 등등이고
 * 이것은 무엇으로 결제할지에 대한 부분이다.
 * 일부는 선결제, 일부는 카드등 여러개로 결제할 수도 있다.
 */
export const payMethodList = [
    /** 현금 */
    {
        code: PAY_CASH_AMOUNT,
        type: 'cash',
        typeForPayload: 'payCashAmount',
        predicate: ({ payCashAmount, }) => payCashAmount > 0,
        amount() {
            return this.payCashAmount;
        },
        shortenText: `${lc}cash_shorten`,
        text: `${lc}cash`,
        color: 'green',
    },
    /** 카드결제 */
    {
        code: PAY_CARD_AMOUNT,
        type: 'card-paid',
        typeForPayload: 'payCardAmount',
        predicate: ({ payCardAmount, cardApproveNumber, }) => payCardAmount > 0 && cardApproveNumber,
        amount() {
            return this.payCardAmount;
        },
        shortenText: `${lc}card_shorten`,
        text: `${lc}card`,
        color: 'blue',
    },
    /** 선결제 */
    {
        code: PRE_PAY_AMOUNT,
        type: 'prepaid',
        typeForPayload: 'prePayAmount',
        predicate: ({ prePayAmount, }) => prePayAmount > 0,
        amount() {
            return this.prePayAmount;
        },
        shortenText: `${lc}pre_pay_shorten`,
        text: `${lc}pre_pay`,
        color: 'purple',
    },
    /** 카드지만 승인 안됨 */
    {
        code: PAY_CARD_AMOUNT,
        type: 'card-unpaid',
        typeForPayload: 'payCardAmount',
        predicate: ({ payCardAmount, cardApproveNumber, }) => payCardAmount > 0 && !cardApproveNumber,
        amount() {
            return this.payCardAmount;
        },
        shortenText: `${lc}card_unpaid_shorten`,
        text: `${lc}card_unpaid`,
        color: 'red',
    },
    /** 0원 결제 */
    {
        code: ZERO_ORDER_AMOUNT,
        type: 'zeroOrderAmount',
        predicate: ({ prePayAmount, payCardAmount, _orderAmount, payCashAmount, }) => [
            prePayAmount,
            payCardAmount,
            payCashAmount,
            _orderAmount,
        ].every((amnt) => amnt === 0),
        amount() {
            return this.orderAmount;
        },
        textColor: 'text-black',
    },
];
